/* OSHA STORE — Dynamic product options + WhatsApp ordering */
(function () {
  const WHATSAPP_NUMBER = '201055674700';

  function cleanupCustomerFacingCopy(root) {
    const base = root && root.querySelectorAll ? root : document;
    base.querySelectorAll('.osha-account-demo-head small, .osha-account-demo-note').forEach(function (element) { element.remove(); });
  }

  function cleanGiftRegionFromTitle(title) {
    const englishTitle = (title || '').split('|')[0].trim();
    return englishTitle
      .replace(/^PlayStation Store Gift Card\s*[—-]\s*/i, '')
      .trim();
  }

  function getGiftRegionData(title, selector) {
    const data = selector && selector.dataset ? selector.dataset : {};
    const explicitName = (data.region || '').trim();
    const explicitCode = (data.regionCode || '').trim();
    const explicitAr = (data.regionAr || '').trim();

    if (explicitName && explicitCode) {
      return { code: explicitCode, name: explicitName, ar: explicitAr || explicitName };
    }

    const region = cleanGiftRegionFromTitle(title);
    if (/^(US|United States)$/i.test(region)) return { code: 'US', name: 'United States', ar: 'الولايات المتحدة' };
    if (/Saudi/i.test(region)) return { code: 'SA', name: 'Saudi Arabia', ar: 'السعودية' };
    if (/^(UAE|United Arab Emirates)$/i.test(region)) return { code: 'UAE', name: 'United Arab Emirates', ar: 'الإمارات' };
    if (/Turkey/i.test(region)) return { code: 'TR', name: 'Turkey', ar: 'تركيا' };

    const compact = region.replace(/[^A-Za-z0-9]/g, '');
    const code = (compact.length <= 3 ? compact : compact.slice(0, 3)).toUpperCase() || 'PSN';
    return { code: code, name: region || 'PlayStation Store', ar: explicitAr || region || 'متجر PlayStation' };
  }

  function ensureGiftCardMedia(root) {
    const base = root && root.querySelectorAll ? root : document;
    const selector = (base.matches && base.matches('[data-osha-giftcard-selector]')) ? base : base.querySelector('[data-osha-giftcard-selector]');
    if (!selector) return;

    const container = document.querySelector('.product-information__media');
    if (!container || container.dataset.oshaGiftMediaReady === 'true') return;

    container.dataset.oshaGiftMediaReady = 'true';
    container.dataset.oshaMediaReady = 'true';
    Array.from(container.children).forEach(function (child) { child.style.display = 'none'; });

    const title = document.querySelector('.product-details h1, .product-information h1')?.textContent?.trim() || document.title;
    const region = getGiftRegionData(title, selector);

    const stage = document.createElement('div');
    stage.className = 'osha-gift-product-stage';
    stage.setAttribute('aria-label', `${region.name} PlayStation Store Gift Card`);
    stage.innerHTML = `
      <div class="osha-gift-product-card">
        <div class="osha-gift-product-top"><span>PLAYSTATION STORE</span><b>DIGITAL GIFT CARD</b></div>
        <div class="osha-gift-product-main">
          <div class="osha-gift-product-code">${region.code}</div>
          <strong>${region.name.toUpperCase()}</strong>
          <span dir="rtl">${region.ar}</span>
        </div>
        <div class="osha-gift-product-bottom"><span>SELECT YOUR CARD VALUE</span><b>OSHA STORE</b></div>
      </div>`;
    container.appendChild(stage);
  }

  function ensureProductMedia(root) {
    const base = root && root.querySelectorAll ? root : document;
    let containers = Array.from(base.querySelectorAll('.product-information__media'));
    if (base.matches && base.matches('.product-information__media')) containers.unshift(base);

    containers.forEach(function (container) {
      /* Digital Games already render their official cover + gameplay gallery in Liquid.
         Never hide or replace that stack with the generic fallback cover. */
      if (container.querySelector('.osha-game-media-stack')) {
        container.dataset.oshaMediaReady = 'true';
        return;
      }

      if (container.dataset.oshaMediaReady === 'true') return;
      if (container.querySelector('.osha-gift-product-stage')) {
        container.dataset.oshaMediaReady = 'true';
        return;
      }

      const ogImage = document.querySelector('meta[property="og:image:secure_url"]')?.content || document.querySelector('meta[property="og:image"]')?.content || document.querySelector('meta[name="twitter:image"]')?.content;
      const nativeImage = container.querySelector('img[src]');
      const source = ogImage || nativeImage?.currentSrc || nativeImage?.src;
      if (!source) return;

      container.dataset.oshaMediaReady = 'true';
      Array.from(container.children).forEach(function (child) {
        child.style.display = 'none';
      });

      const frame = document.createElement('div');
      frame.className = 'osha-direct-product-media';
      frame.style.cssText = 'width:100%;display:flex;align-items:center;justify-content:center;min-width:0;';

      const image = document.createElement('img');
      image.src = source;
      image.alt = document.querySelector('.product-details h1, .product-information h1')?.textContent?.trim() || 'Product cover';
      image.loading = 'eager';
      image.decoding = 'async';
      image.style.cssText = 'display:block;width:100%;height:auto;max-width:100%;object-fit:contain;border-radius:14px;';

      frame.appendChild(image);
      container.appendChild(frame);
    });
  }

  function getScope(element) {
    return element.closest('.product-details') || element.closest('.product-information') || document;
  }

  function getSelected(scope) {
    return scope.querySelector('[data-osha-giftcard-option]:checked, [data-osha-account-option]:checked');
  }

  function getTitle(scope) {
    return scope.querySelector('h1')?.textContent?.trim() || document.querySelector('.product-details h1')?.textContent?.trim() || document.title.split('–')[0].trim() || 'PlayStation product';
  }

  function buildMessage(title, selected, price) {
    if (selected && selected.matches('[data-osha-giftcard-option]')) {
      return [
        'Hi OSHA!',
        'I want to buy: PlayStation Store Gift Card',
        `Region: ${selected.dataset.region || 'Selected region'}`,
        `Value: ${selected.dataset.value || 'Selected value'}`,
        `Price: ${price}`
      ].join('\n');
    }

    const plusMatch = title.match(/^PlayStation Plus\s+(Premium|Extra|Essential)\s+[—-]\s+(.+)$/i);
    if (plusMatch) {
      return [
        'Hi OSHA!',
        'I want to buy: PlayStation Plus',
        `Plan: ${plusMatch[1]}`,
        `Duration: ${plusMatch[2]}`,
        `Account type: ${selected?.dataset.account || 'Selected option'}`,
        `Price: ${price}`
      ].join('\n');
    }
    return [
      'Hi OSHA!',
      `I want to buy: ${title}`,
      `Account type: ${selected?.dataset.account || 'Selected option'}`,
      `Price: ${price}`
    ].join('\n');
  }

  function updateSelection(scope) {
    const selected = getSelected(scope);
    if (!selected) return;
    const price = selected.dataset.price || '';
    const priceNode = scope.querySelector('[data-osha-selected-price]');
    if (priceNode && price) {
      priceNode.textContent = price;
      priceNode.classList.remove('is-changing');
      void priceNode.offsetWidth;
      priceNode.classList.add('is-changing');
    }
    scope.querySelectorAll('.osha-game-product-whatsapp').forEach(function (button) {
      const message = buildMessage(getTitle(scope), selected, price);
      button.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    });
  }

  function initSelector(selector) {
    if (!selector || selector.dataset.oshaSelectorReady === 'true') return;
    selector.dataset.oshaSelectorReady = 'true';
    const scope = getScope(selector);
    selector.querySelectorAll('[data-osha-account-option], [data-osha-giftcard-option]').forEach(function (radio) {
      radio.addEventListener('change', function () { updateSelection(scope); });
    });
    updateSelection(scope);
  }

  function initButton(button) {
    if (!button || button.dataset.oshaWhatsappReady === 'true') return;
    button.dataset.oshaWhatsappReady = 'true';
    const scope = getScope(button);
    button.addEventListener('click', function () { updateSelection(scope); });
    updateSelection(scope);
  }

  function init(root) {
    const base = root && root.querySelectorAll ? root : document;
    cleanupCustomerFacingCopy(base);
    ensureGiftCardMedia(base);
    ensureProductMedia(base);
    base.querySelectorAll('[data-osha-account-selector], [data-osha-giftcard-selector]').forEach(initSelector);
    base.querySelectorAll('.osha-game-product-whatsapp').forEach(initButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();